export default __webpack_public_path__ + "static/media/kinder11.098d8541.jpg";